/**
 * @file 通用数据处理方法
 * @author guozhihao02
 * @description 包含数据处理的通用 js 方法，如果不包含具体数据处理，请写到 Utils.js 文件中
 */
import request from 'http/request';
import URLS from 'http/URLS';
import {getStorage, setStorage} from 'js/core';

function setDataFromStorage(modelId, modelName) {
    let tmp = (getStorage('CONTRAST_DATA') || {}).data || [];
    tmp = [{id: modelId, modelName}, ...tmp];
    setStorage('CONTRAST_DATA', {data: tmp});
}
function delDataFromStorage(modelId) {
    let tmp = (getStorage('CONTRAST_DATA') || {}).data || [];
    tmp = tmp.filter(v => v.id !== modelId);
    setStorage('CONTRAST_DATA', {data: tmp});
}

export function setModel(modelId, modelName) {
    /* eslint-disable fecs-camelcase */
    request(URLS.setModel, {
        model_id: modelId,
        model_name: modelName
    });
    /* eslint-enable fecs-camelcase */
    setDataFromStorage(modelId, modelName);
}

export function delModel(modelId) {
    /* eslint-disable fecs-camelcase */
    request(URLS.delModel, {
        model_id: modelId
    });
    /* eslint-enable fecs-camelcase */
    delDataFromStorage(modelId);
}
